import { useTranslation } from "next-i18next";

function EmptyState({ value = "" }) {
  const { t } = useTranslation();

  return (
    <div className="rounded border border-gray-300 p-10 text-center">
      <h3 className="mt-2 text-sm font-medium text-gray-900">{t("generic.noResults")}</h3>
      <p className="mt-1 text-sm text-gray-500">{t("generic.valueNotFound", { value })}</p>
    </div>
  );
}

export default EmptyState;
